

import Event = createjs.Event;

export class BasicAssetsEvent extends Event {
    public static ASSETS_COMPLETE: string = "assetsComplete";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

